import { combineReducers } from 'redux-immutable'
import lobCreateReducer from './lob-create-reducer'
import lobListReducer from './lob-list-reducer'
import lobEditReducer from './lob-edit-reducer'
import lobGetReducer from './lob-get-reducer'
import lobDeactivateReducer from './lob-deactivate-reducer'
import lobExportReducer from './lob-export-reducer'

export default combineReducers({
  lobCreate: lobCreateReducer,
  lobList: lobListReducer,
  lobEdit: lobEditReducer,
  lobGet: lobGetReducer,
  lobDeactivate: lobDeactivateReducer,
  lobExport: lobExportReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/lob/index.js